/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useState} from "react";

import useTypedSelector from "@Services/Hooks/UseTypedSelector";


import ApplicationApiContext from "@Contexts/Api";


import REST_API_REQUEST from "@Services/Utilities/Requests";
import REST_API_RESPONSE_CONTENT_HANDLER from "@Services/Utilities/Responses";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentPictureComponent from "@Components/UI/Containers/Block/Picture";


import MonitoryNotesListComponent from "@UIPages/Authenticated/MonitoryNotes/MonitoryNotesList";


import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";


import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";



type HomePageComponentProps = {};


export const HomePageComponent: React.FC<HomePageComponentProps> = (): JSX.Element | null => {


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {AUTHORIZATION_TOKEN_INTERFACE} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [MONITORY_NOTES, SET_MONITORY_NOTES] = useState<MONITORY_NOTE_INTERFACE[] | null>(null);
    const [MONITORY_NOTES_ERROR, SET_MONITORY_NOTES_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);


    useEffect(() => {

        if (!REST_API_URL || !LOGGED_USER?.userID) return;

        const MONITORY_NOTES_API_URL: string = `${REST_API_URL}/TransportNotification/List`;

        const MONITORY_NOTES_REQUEST_DATA = {UserId: LOGGED_USER?.userID, Today: true};

        const GET_MONITORY_NOTES = async (): Promise<any> => {

            try {

                const MONITORY_NOTES_RESPONSE = await REST_API_REQUEST(
                    MONITORY_NOTES_API_URL,
                    MONITORY_NOTES_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                const MONITORY_NOTES_RESPONSE_CONTENT = await REST_API_RESPONSE_CONTENT_HANDLER(MONITORY_NOTES_RESPONSE);

                if (MONITORY_NOTES_RESPONSE_CONTENT.ERROR) {
                    SET_MONITORY_NOTES_ERROR({ErrorCode: MONITORY_NOTES_RESPONSE_CONTENT.ERROR.ERROR_CODE, UserMessage: MONITORY_NOTES_RESPONSE_CONTENT.ERROR.ERROR_MESSAGE});
                } else {
                    SET_MONITORY_NOTES(MONITORY_NOTES_RESPONSE_CONTENT.DATA?.TransportNotifications || []);
                }

            } catch (e) {
                SET_MONITORY_NOTES_ERROR({ErrorCode: 599, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

        };

        GET_MONITORY_NOTES();

    }, []);


    useEffect(() => {
        return () => {
            SET_MONITORY_NOTES(null);
            SET_MONITORY_NOTES_ERROR(null);
        };
    }, []);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;


    return (
        <BlockContentContainerComponent cssClasses={"home-page-component"}>

            <BlockContentPictureComponent headerPictureType={1} />

            {!!MONITORY_NOTES_ERROR && <ErrorMessageComponent messageText={MONITORY_NOTES_ERROR.UserMessage} />}

            {!!MONITORY_NOTES &&
	        <MonitoryNotesListComponent
		        MONITORY_NOTES={MONITORY_NOTES}
		        MONITORY_NOTES_LIST_TYPE={"HOME"}
	        />
            }

        </BlockContentContainerComponent>
    );

};


export default HomePageComponent;
